import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { ArrowRightLeft, Download, MoreHorizontal, RefreshCw } from "lucide-react";
import React from "react";
import InventoryItemCard, { InventoryItemData, Priority, VerificationStatus } from "./inventory-item-card";

const Component: React.FC = () => {
    const inventoryItems: InventoryItemData[] = [
        {
            name: "Aspirin 500mg",
            location: "Shelf A1",
            system_qty: 100,
            counted_qty: 95,
            variance: -5,
            status: VerificationStatus.DISCREPANCY,
            priority: Priority.HIGH,
            last_counted: "2024-06-10",
        },
        {
            name: "Vitamin C 1000mg",
            location: "Shelf B2",
            system_qty: 80,
            counted_qty: 80,
            variance: 0,
            status: VerificationStatus.VERIFIED,
            priority: Priority.MEDIUM,
            last_counted: "2024-06-11"
        },
        {
            name: "Calcium Carbonate 600mg",
            location: "Shelf C3",
            system_qty: 120,
            counted_qty: 125,
            variance: 5,
            status: VerificationStatus.DISCREPANCY,
            priority: Priority.LOW,
            last_counted: "2024-06-12"
        },
        {
            name: "Magnesium 400mg",
            location: "Shelf D1",
            system_qty: 60,
            counted_qty: null,
            variance: 0,
            status: VerificationStatus.PENDING,
            priority: Priority.MEDIUM,
            last_counted: "2024-05-28",
        },
        {
            name: "Zinc 25mg",
            location: "Shelf E2",
            system_qty: 200,
            counted_qty: null,
            variance: 0,
            status: VerificationStatus.IN_PROGRESS,
            priority: Priority.LOW,
            last_counted: "2024-06-01"
        },
        {
            name: "Iron 65mg",
            location: "Shelf F3",
            system_qty: 90,
            counted_qty: 90,
            variance: 0,
            status: VerificationStatus.VERIFIED,
            priority: Priority.MEDIUM,
            last_counted: "2024-06-13"
        },
        {
            name: "B-Complex",
            location: "Shelf A2",
            system_qty: 150,
            counted_qty: null,
            variance: 0,
            status: VerificationStatus.PENDING,
            priority: Priority.HIGH,
            last_counted: "2024-05-25"
        },
        {
            name: "Omega-3 1000mg",
            location: "Shelf B1",
            system_qty: 75,
            counted_qty: 70,
            variance: -5,
            status: VerificationStatus.DISCREPANCY,
            priority: Priority.MEDIUM,
            last_counted: "2024-06-14"
        },
        {
            name: "Vitamin D3 2000IU",
            location: "Shelf C1",
            system_qty: 110,
            counted_qty: 115,
            variance: 5,
            status: VerificationStatus.DISCREPANCY,
            priority: Priority.LOW,
            last_counted: "2024-06-15"
        },
        {
            name: "Probiotics 50B",
            location: "Shelf D2",
            system_qty: 45,
            counted_qty: null,
            variance: 0,
            status: VerificationStatus.PENDING,
            priority: Priority.HIGH,
            last_counted: "2024-05-20",
        }
    ];

    return (
        <div className="flex flex-col items-start justify-start p-4 w-full">
            <Card className="bg-[#FFFFFF] relative border rounded-2xl w-full">
                <CardContent className="w-full p-6 flex flex-col items-start justify-start gap-y-2">
                    <div className="flex flex-row items-center justify-between w-full mb-4">
                        <div className="flex flex-col items-start justify-center">
                            <span className="font-semibold text-xl">Count & Verify Inventory</span>
                            <span className="font-normal text-base text-gray-400 mb-4">Perform physical inventory counts and verify against system records</span>
                        </div>
                        <div className="flex flex-row items-center justify-end gap-x-2">
                            <Button variant="ghost"><RefreshCw /></Button>
                            <span className="text-medium text-sm">Last Updated 2m ago</span>
                            <Button variant="ghost"><MoreHorizontal /></Button>
                        </div>
                    </div>
                    <div className="flex flex-row items-center justify-start w-full mb-4 gap-x-2">
                        <Input 
                            placeholder="Search inventory, product, etc."
                            className="max-w-[280px]"
                        />
                        <Button variant="outline" className="w-10 p-0 rounded-[12px]"><Download className="h-5 w-5" /></Button>
                        <Button variant="outline"  className="flex flex-row items-center justify-center px-6 rounded-[12px]"><ArrowRightLeft className="mr-2"/>Sort</Button>
                    </div>
                    {inventoryItems.map((item, index) => (
                        <InventoryItemCard key={index} {...item} />
                    ))}
                </CardContent>
            </Card>
        </div>
    );
};

export default Component;